import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enUS from './en-US.json'
import zhTW from './zh-TW.json'
import zhCN from './zh-CN.json'
import myMM from './my-MM.json'
import jaJP from './ja-JP.json'
import viVN from './vi-VN.json'
import thTH from './th-TH.json'
import koKR from './ko-KR.json'
import kmKH from './km-KH.json'
import idID from './id-ID.json'
import msMY from './ms-MY.json'
import filPH from './fil-PH.json'
import { LANDING_VERSION } from '@/pages/landing/version'

type Translate = keyof typeof resources

export const languageList = [
  { short: '繁中', text: '繁體中文', value: 'zh-TW' },
  { short: '简中', text: '简体中文', value: 'zh-CN' },
  { short: 'EN', text: 'English', value: 'en-US' },
  { short: 'MY', text: 'မြန်မာစကား', value: 'my-MM' },
  { short: 'Tiếng Việt', text: 'Tiếng Việt', value: 'vi-VN' },
  { short: '日本語', text: '日本語', value: 'ja-JP' },
  { short: 'TH', text: 'ไทย', value: 'th-TH' },
  { short: 'KO', text: '한국어', value: 'ko-KR' },
  { short: 'KM', text: 'ភាសាខ្មែរ', value: 'km-KH' },
  { short: 'ID', text: 'Bahasa Indonesia', value: 'id-ID' },
  { short: 'MS', text: 'Bahasa Melayu', value: 'ms-MY' },
  { short: 'PH', text: 'Filipino', value: 'fil-PH' },
]

// i18next resource
const resources = {
  'en-US': { translation: enUS },
  'zh-TW': { translation: zhTW },
  'zh-CN': { translation: zhCN },
  'my-MM': { translation: myMM },
  'ja-JP': { translation: jaJP },
  'vi-VN': { translation: viVN },
  'th-TH': { translation: thTH },
  'ko-KR': { translation: koKR },
  'km-KH': { translation: kmKH },
  'id-ID': { translation: idID },
  'ms-MY': { translation: msMY },
  'fil-PH': { translation: filPH },
}

// nox 版 postProcessor：把翻譯字串裡的品牌/角色詞彙換成 NOX 對應：
//   - "SoFinX"          → "NOX"                （case-sensitive，避開 sofinx.com email/URL）
//   - "Signal Provider" → "Data Contributor"   （含單複數、大小寫變體）
// 公司名 "OTSO Fintech Consultant Co., Limited" 不含關鍵字、不受影響。
const noxBrandPostProcessor = {
  type: 'postProcessor' as const,
  name: 'noxBrand',
  process: (value: string) => {
    if (LANDING_VERSION !== 'nox') return value
    if (typeof value !== 'string') return value
    return value
      .replace(/SoFinX/g, 'NOX')
      // 用 word-boundary + 捕捉 's' 保留單複數；先匹配大寫開頭
      .replace(/\bSignal Provider(s?)\b/g, 'Data Contributor$1')
      .replace(/\bsignal provider(s?)\b/g, 'data contributor$1')
  },
}

export const initLanguage = () => {
  i18n
    .use(initReactI18next)
    .use(noxBrandPostProcessor)
    .init({
      resources,
      lng: getDefaultLanguage(),   //預設語言
      fallbackLng: 'en-US',       //如果當前切換的語言沒有對應的翻譯則使用這個語言，
      interpolation: {
        escapeValue: false,
      },
      postProcess: LANDING_VERSION === 'nox' ? ['noxBrand'] : [],
    })

}

export function getDefaultLanguage () {
  const local = localStorage.getItem('language')
  const browser = resources[navigator.language as Translate] ? navigator.language : 'en-US'
  return local || browser
}

export default i18n
